import type { PortalNotification } from '../lib/api.ts';
import { formatDateTime, humanize } from '../lib/format.ts';
import { EmptyState } from './ui.tsx';

interface Props {
  notifications: PortalNotification[];
}

const LABEL: Record<PortalNotification['type'], string> = {
  report_available: 'Report available',
  case_closed: 'Case closed',
  case_archived: 'Case archived',
};

/** The derived, read-only notifications feed (report-available + case milestones). */
export function NotificationsFeed({ notifications }: Props): JSX.Element {
  if (notifications.length === 0) {
    return (
      <EmptyState
        compact
        title="No notifications"
        description="Report releases and case milestones appear here."
      />
    );
  }
  return (
    <ol className="argus-feed" aria-label="Notifications">
      {notifications.map((n, i) => (
        <li key={`${n.type}-${n.case_number}-${n.at}-${i}`} className="argus-feed__item">
          <span className="argus-feed__dot" aria-hidden="true" />
          <div className="argus-feed__body">
            <span className={`portal-feed__label type-${n.type}`}>
              {LABEL[n.type] ?? humanize(n.type)}
            </span>
            <span>{n.title}</span>
            <span className="argus-feed__meta text-muted">
              <span className="mono">{n.case_number}</span>
              <span>{formatDateTime(n.at)}</span>
            </span>
          </div>
        </li>
      ))}
    </ol>
  );
}
